import domService from '../services/DomService';
import storeManager from '../store/StoreManager';
import sessionActions from '../actions/SessionActions';
import sessionConstants from '../constants/SessionConstants';
import timeActions from '../actions/TimeActions';
import multimediaEvents from '../components/question/media/multimedia/MultimediaEvents';
import assessmentReader from '../store/readHelpers/AssessmentReader';
import backgroundAudioService from './BackgroundAudioService';
import settingsReader from '../store/readHelpers/SettingsReader';
import idleWarningService from './IdleWarningService';
import timeService from './TimeService';
import marketplacePropertiesService from './MarketplacePropertiesService';
import pendingResumeNavigation from '../constants/PendingResumeNavigation';
import idVerificationService from './idverification/IdVerificationService';

/**
 * Simple service used to handle push messages related to pause state
 * @type {{updatePauseState: (function(*=))}}
 */
const pauseService = {
    pause(pauseTime) {
        console.info('INDICATOR: Assessment run became paused');

        if (marketplacePropertiesService.isPauseWithStopTimeEnabled()) {
            timeService.stopTime();
        }
        if (pauseTime > 0) {
            storeManager.dispatch(timeActions.setPauseTime(pauseTime));
        }
        this.triggerPauseMultimediaPlaybackEvent();
        this.turnPauseNavigationLockOn();
        this.pauseBackgroundAudio();
        this.pauseIdleWarningTimer();
        timeService.fetchTimeRemaining(true, true);
    },

    resume() {
        console.info('INDICATOR: Assessment run became resumed');

        if (marketplacePropertiesService.isPauseWithStopTimeEnabled()) {
            timeService.resumeTime();
        }
        this.turnPauseNavigationLockOff();
        this.resumeBackgroundAudio();
        this.resumeIdleWarningTimer();
        timeService.fetchTimeRemaining(true, true);

        this.navigateOnResume();
    },

    navigateOnResume() {
        const { time } = storeManager.getState();

        switch (time.pendingResumeNavigation) {
        case pendingResumeNavigation.PHOTO_RETAKE:
            idVerificationService.gotoPhotoRetake();
            break;
        default:
            return;
        }

        storeManager.dispatch(timeActions.resetPendingResumeNavigation());
    },

    unLockPauseResumeUpdateLockPeriod() {
        storeManager.dispatch(timeActions.setIsPauseResumeUpdateLockPeriodActive(false));
    },

    triggerPauseMultimediaPlaybackEvent() {
        domService.dispatchEvent(window, multimediaEvents.STOP_ALL_PLAYBACK);
    },

    pauseBackgroundAudio() {
        const hasBackgroundAudio = assessmentReader.hasBackgroundAudioResource();
        if (hasBackgroundAudio) {
            backgroundAudioService.pause();
        }
    },

    resumeBackgroundAudio() {
        const hasBackgroundAudio = assessmentReader.hasBackgroundAudioResource();
        // Audio should not play from start on resume when audio ended
        if (hasBackgroundAudio) {
            backgroundAudioService.resume();
        }
    },

    pauseIdleWarningTimer() {
        if (settingsReader.isIdleStateWarningEnabled()) {
            idleWarningService.pauseTimer();
        }
    },

    resumeIdleWarningTimer() {
        if (settingsReader.isIdleStateWarningEnabled()) {
            idleWarningService.startTimer();
        }
    },

    turnPauseNavigationLockOff() {
        storeManager.dispatch(sessionActions.toggleNavigationLock(false));
    },

    turnPauseNavigationLockOn() {
        storeManager.dispatch(sessionActions.toggleNavigationLock(
            true,
            sessionConstants.LOCK.TEST_PAUSED,
            null,
        ));
    },
};

export default pauseService;
